export default "__VITE_ASSET__13184899__"